import { FileUploadWUT } from '@wix/form-fields/wut';

export default FileUploadWUT;
